import React from "react";
import { TextField } from "@mui/material";

export default function CustomDatePicker({ label, value, onChange }) {
    return (
        <TextField
            type="date"
            size="small"
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
                minWidth: 200,
                "& .MuiInputBase-root": {
                    borderRadius: 2,
                    paddingY: 0,
                    fontWeight:300,
                },
                "& .MuiOutlinedInput-input": {
                    paddingY: "8px",
                    fontWeight:300,
                },
            }}
        />
    );
}
